// 全局组件导入
import Vue from "vue";
import SearchTemp from "@/components/common/Search.vue";
import TabelTemp from "@/components/common/Table.vue";
import TableTempNoCard from "@/components/common/TableNoCard.vue";
import NewTable from "@/components/common/NewTable.vue";
import NewSearch from "@/components/common/NewSearch.vue";
import PreviewCom from "@/components/common/PreviewCom.vue";
import FormItem from "@/components/common/FormItem";
import FormDetail from "@/components/common/FormDetail";
import FileUpload from "@/components/common/FileUpload";
import UserSelect from "@/components/common/UserSelect";
import AppCard from "@/components/common/AppCard";
import AppChart from "@/components/common/AppChart";
import Tree from "@/components/common/tree.vue";
import UploadFile from "@/components/common/UploadFile.vue";
// 公共组件
let components = [
  SearchTemp,
  TabelTemp,
  NewTable,
  NewSearch,
  PreviewCom,
  FormItem,
  FormDetail,
  UserSelect,
  FileUpload,
  AppCard,
  AppChart,
  TableTempNoCard,
  Tree,
  UploadFile,
];

// 遍历注册全局组件
components.map((el) => {
  Vue.component(el.name, el);
});
